/* eslint-disable */
import React, { useState, useEffect } from "react";
import { BsCartPlus } from "react-icons/bs";
import { IoClose } from "react-icons/io5";
import "./AddToCartModal.css";

/**
 * AddToCartModal
 * Props:
 *  product   – the product object
 *  carts     – current cart array from Redux
 *  onAdd     – fn(payload) called when user confirms
 *  onClose   – fn() called to close the modal
 */
function AddToCartModal({ product, carts, onAdd, onClose }) {
  const cartLocked = carts?.length > 0;
  const lockedPeriod = cartLocked ? Number(carts[0]?.period) : null;

  // `quantity` on the product mirrors AVAILABLE inventory stock.
  const available = Number(product?.quantity ?? 0);
  const outOfStock = available <= 0;

  const [selectedPeriod, setSelectedPeriod] = useState(
    cartLocked ? lockedPeriod : 3
  );
  const [monthlyPrice, setMonthlyPrice] = useState(null);

  const calcPrice = (period) => {
    const adminCharge = 3 / 100;
    const retailPrice = Number(product?.new_price);
    let percentChange = 1.1;
    if (Number(period) === 18) percentChange = 1.145;
    const adminAmount = retailPrice * adminCharge;
    const initialAmount = retailPrice * percentChange + adminAmount;
    return Number(initialAmount / period).toFixed(2);
  };

  useEffect(() => {
    setMonthlyPrice(calcPrice(selectedPeriod));
  }, [selectedPeriod, product]);

  const handlePeriodChange = (e) => {
    setSelectedPeriod(Number(e.target.value));
  };

  const handleConfirm = () => {
    if (outOfStock) return;
    const payload = {
      size: "",
      color: "",
      quantity: 1,
      product_id: product?._id,
      period: selectedPeriod,
      period_price: monthlyPrice,
    };
    onAdd(payload);
    onClose();
  };

  return (
    <div className="atcModal-overlay" onClick={onClose}>
      <div className="atcModal-card" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="atcModal-header">
          <span className="atcModal-title">Select Payment Term</span>
          <button className="atcModal-close" onClick={onClose}>
            <IoClose size={18} />
          </button>
        </div>

        {/* Product preview */}
        <div className="atcModal-product">
          <div className="atcModal-imgWrap">
            <img
              src={product?.images?.[0]?.url}
              alt={product?.product_name}
              className="atcModal-img"
            />
          </div>
          <div className="atcModal-productInfo">
            <p className="atcModal-productName">
              {product?.product_name?.length > 60
                ? product?.product_name.slice(0, 60) + "..."
                : product?.product_name}
            </p>
            <p className="atcModal-retailPrice">
              Retail price: &#8373;{product?.new_price}
            </p>
            <p
              style={{
                marginTop: 4,
                fontSize: 12,
                fontWeight: 600,
                color: outOfStock ? "#dc2626" : "#16a34a",
              }}
            >
              {outOfStock ? "Out of stock" : `In stock: ${available} available`}
            </p>
          </div>
        </div>

        <div className="atcModal-divider" />

        {/* Term selection */}
        <div className="atcModal-termSection">
          <label className="atcModal-label">
            {cartLocked
              ? "Payment term (locked to your active cart)"
              : "Choose payment term"}
          </label>

          {cartLocked ? (
            <div className="atcModal-lockedPeriod">
              {lockedPeriod} months
              <span className="atcModal-lockedNote">
                (matches your current cart)
              </span>
            </div>
          ) : (
            <div className="atcModal-periodOptions">
              {[3, 6, 12, 18].map((p) => (
                <button
                  key={p}
                  className={`atcModal-periodBtn ${
                    selectedPeriod === p ? "active" : ""
                  }`}
                  onClick={() => setSelectedPeriod(p)}
                >
                  {p} mo
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Monthly price */}
        <div className="atcModal-priceBox">
          <span className="atcModal-priceLabel">Monthly payment</span>
          <span className="atcModal-price">&#8373;{monthlyPrice}</span>
          <span className="atcModal-priceSub">
            × {selectedPeriod} months
          </span>
        </div>

        {/* Actions */}
        <div className="atcModal-actions">
          <button className="atcModal-cancelBtn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="atcModal-addBtn"
            onClick={handleConfirm}
            disabled={outOfStock}
            style={outOfStock ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
          >
            <BsCartPlus size={15} />
            {outOfStock ? "Out of Stock" : "Add to Cart"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddToCartModal;
